"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveAgendaSlotResponseSchema = exports.moveAgendaSlotDataResponseSchema = exports.moveAgendaSlotSlotResponseSchema = exports.moveAgendaSlotApiPayloadSchema = void 0;
const zod_1 = require("zod");
exports.moveAgendaSlotApiPayloadSchema = zod_1.z.object({
    targetSlotId: zod_1.z.string().uuid(),
    reservationId: zod_1.z.string().uuid().optional(),
});
exports.moveAgendaSlotSlotResponseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    status: zod_1.z.enum(['open', 'pending', 'confirmed']),
});
exports.moveAgendaSlotDataResponseSchema = zod_1.z.object({
    message: zod_1.z.string(),
    sourceSlot: exports.moveAgendaSlotSlotResponseSchema,
    targetSlot: exports.moveAgendaSlotSlotResponseSchema,
});
exports.moveAgendaSlotResponseSchema = zod_1.z.object({
    data: exports.moveAgendaSlotDataResponseSchema,
});
